module.exports = __webpack_public_path__ + "static/media/Lillia_0.957b1ca5.png";